// src/_ApiConn/apiRatings.js
import axios from "axios";
import ConnUrls from '../Connections/ConnectURL';

const submitRating = async (restId, rating, comment = "") => {
    const usrtoken = localStorage.getItem('usrtoken');
    let response = await axios.post(ConnUrls.ApiUrl + "ratings/submit", {
        restId,
        rating,
        comment,
        usrtoken
    });
    return response.data;
}

const getUserRating = async (restId) => {
    const usrtoken = localStorage.getItem('usrtoken');
    let response = await axios.get(ConnUrls.ApiUrl + `ratings/user/${restId}`, {
        headers: { usrtoken }
    });
    return response.data;
}

const getRestaurantRating = async (restId) => {
    let response = await axios.get(ConnUrls.ApiUrl + `ratings/restaurant/${restId}`);
    return response.data;
}

const getAllReviews = async (restId) => {
    let response = await axios.get(ConnUrls.ApiUrl + `ratings/reviews/${restId}`);
    return response.data;
}

export default {
    submitRating,
    getUserRating,
    getRestaurantRating,
    getAllReviews
};